export const dataHooks = {
  contentContainer: 'content-container',
  imageContainer: 'image-container',
  footerContainer: 'footer-container',
};

export const horizontalSize = {
  medium: 'medium',
  large: 'large',
};

export const verticalSize = {
  medium: 'medium',
  large: 'large',
};
